import { ISearchHistoryResultModel } from "../Interfaces";

export const SearchHistoryModel: ISearchHistoryResultModel = {
  data: [],
  isError: false,
  isLoading: false,
};
